var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 23,
    viewBox: "0 0 21 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.954559 23C0.701394 23 0.458599 22.899 0.279584 22.7193C0.10057 22.5396 0 22.2958 0 22.0417V0.958176C2.8399e-05 0.791645 0.0432803 0.627995 0.125493 0.483357C0.207705 0.338719 0.326041 0.218086 0.468835 0.133347C0.611629 0.0486076 0.773953 0.00268799 0.939807 0.000114467C1.10566 -0.00245906 1.26932 0.0384023 1.41466 0.11867L20.5058 10.6604C20.6555 10.7431 20.7803 10.8647 20.8672 11.0123C20.9541 11.16 21 11.3284 21 11.4999C21 11.6714 20.9541 11.8398 20.8672 11.9875C20.7803 12.1352 20.6555 12.2567 20.5058 12.3394L1.41466 22.8812C1.27372 22.9591 1.11545 22.9999 0.954559 23Z",
    fill: "#D7DEE4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.8a8c1bfaa53da8bf59ab580d0de7d271.svg";
export { ForwardRef as ReactComponent };